const isDev = import.meta.env.DEV

export const logger = {
  log: (...args: any[]) => {},
  warn: (...args: any[]) => {},
  error: (...args: any[]) => {},
  info: (...args: any[]) => {},
  debug: (...args: any[]) => {},
}
